import {KycTierLimit, TransactionSubType, TransactionType} from '../types/kycTierLimit';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {KycTier} from '~local/app/shared/types/KycTier';
import {catchError, map} from 'rxjs/operators';

export type KycTierLimitResponse = {
    name: string,
    currencyCode: string,
    maxAmount: string,
    minAmount: string,
};

export type KycTierAndLimit = Pick<KycTier, 'name'> & {currencyCode: string, minAmount: number, maxAmount: number};

export function kycTierLimitResponseToTierLimit($response: KycTierLimitResponse): KycTierAndLimit {
    return Object.keys($response).reduce(($acc, $property) => {
        if ($property === 'maxAmount' || $property === 'minAmount') {
            return {
                ...$acc,
                [$property]: parseFloat($response[$property]),
            };
        }
        return {
            ...$acc,
            [$property]: $response[$property],
        };
    }, { name: '', currencyCode: '', minAmount: 0, maxAmount: 0});
}

@Injectable({providedIn: 'root'})
export class KycTierService {
    public constructor(
        private httpClient: HttpClient,
    ) {
    }

    public getTierLimits(): Observable<Array<KycTierLimit>> {
        return this.httpClient.get<Array<KycTierLimit>>('/identity/limit').pipe(
            catchError(($) => {
                console.error($);
                return [];
            })
        );
    }

    public getKycTierLimits($type: TransactionType, $subType: TransactionSubType): Observable<KycTierAndLimit> {
        return this.httpClient.get<any>(`/settings/tier/${$type}/${$subType}`).pipe(
            map($ => kycTierLimitResponseToTierLimit($)),
        );
    }
}
